export type WorkflowArea = 'tickets' | 'purchases';

export const WORKFLOW_STATUS_VARIANTS: Record<string, string> = {
  novo: 'warning',
  aberto: 'warning',
  em_andamento: 'info',
  aguardando_aprovacao: 'warning',
  aguardando_informacao_usuario: 'secondary',
  aguardando_terceiros: 'secondary',
  aguardando_evidencia: 'secondary',
  aguardando_problema: 'secondary',
  aguardando_implantacao: 'secondary',
  resolvido: 'success',
  aprovado: 'success',
  concluido: 'success',
  rejeitado: 'danger',
  cancelado: 'danger',
  bloqueado: 'danger',
  rascunho: 'secondary',
  fechado: 'dark',
};

export const WORKFLOW_PRIORITY_VARIANTS: Record<string, string> = {
  p1: 'danger',
  p2: 'warning',
  p3: 'info',
  p4: 'success',
};

const BASE_STATUS_LABELS: Record<string, string> = {
  aberto: 'Aberto',
  em_andamento: 'Em Andamento',
  aguardando_aprovacao: 'Aguardando Aprovação',
  aguardando_informacao_usuario: 'Aguardando Informação do Usuário',
  aguardando_terceiros: 'Aguardando Terceiros',
  aguardando_evidencia: 'Aguardando Evidência',
  aguardando_problema: 'Aguardando Problema',
  aguardando_implantacao: 'Aguardando Implantação',
  resolvido: 'Resolvido',
  aprovado: 'Aprovado',
  concluido: 'Concluído',
  rejeitado: 'Rejeitado',
  cancelado: 'Cancelado',
  bloqueado: 'Bloqueado',
  rascunho: 'Rascunho',
  fechado: 'Fechado',
};

const TICKETS_STATUS_LABELS: Record<string, string> = {
  ...BASE_STATUS_LABELS,
  novo: 'Aberto',
};

const PURCHASES_STATUS_LABELS: Record<string, string> = {
  ...BASE_STATUS_LABELS,
  novo: 'Novo',
};

export function getWorkflowStatusVariant(status: string): string {
  return WORKFLOW_STATUS_VARIANTS[status] || 'secondary';
}

export function getWorkflowStatusLabel(status: string, area: WorkflowArea = 'tickets'): string {
  const areaLabels = area === 'purchases' ? PURCHASES_STATUS_LABELS : TICKETS_STATUS_LABELS;
  return areaLabels[status] || status;
}

export function getWorkflowPriorityVariant(priority: string): string {
  return WORKFLOW_PRIORITY_VARIANTS[priority] || 'secondary';
}

export function getWorkflowPriorityLabel(priority: string): string {
  if (!priority) return 'N/A';
  return priority.toUpperCase();
}
